<ngx-extended-pdf-viewer [src]="'/assets/pdf/iDREAMSTermsandConditions.pdf'" [height]="'100vh'"
  [useBrowserLocale]="true" [textLayer]="true" [showHandToolButton]="true">
</ngx-extended-pdf-viewer>